import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { volteDropRateChartConfig } from '../chartConfigs';

/**
 * Props for the VoLteDropRateEcharts component
 */
interface VoLteDropRateEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * VoLTE Drop Rate Chart (LTE Site Level)
 * 
 * Displays Voice over LTE call drop metrics across all cells:
 * - Number of VoLTE Drops (count)
 * - VoLTE Drop Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (volteDropRateChartConfig)
 * @see API: /api/lte/volte-drop-rate?site_name={siteName}
 */
const VoLteDropRateEcharts: React.FC<VoLteDropRateEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={volteDropRateChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default VoLteDropRateEcharts;
